module.exports = __webpack_public_path__ + "img/bg_video4.a57549f5.jpg";